<template>
  <section class="container section pt-5" v-show="show">
    <div v-if="step == 'order'">
      <div class="button mb-3 is-primary is-rounded" @click="$emit('home')">
        <span class="icon">
          <i class="fa fa-arrow-left"></i>
        </span>
        <span>{{ $t("back") }}</span>
      </div>
      <article class="message is-info">
        <div class="message-body">
          <div class="content">
            <div>
              {{ $t("PAYMENT_DISCLAIMER_HEADER") }}.
              <ul>
                <li v-if="order_link && order_link.bank">
                  {{ $t("bank") }}: {{ order_link.bank }}
                </li>
                <li v-if="order_link && order_link.bank_account_name">
                  {{ $t("account name") }}:
                  {{ order_link.bank_account_name }}
                </li>
                <li v-if="order_link && order_link.bank_account_type">
                  {{ $t("account type") }}:
                  {{ $t(order_link.bank_account_type) }}
                </li>
                <li v-if="order_link && order_link.bank_account_number">
                  {{ $t("account number") }}:
                  {{ order_link.bank_account_number }}
                  <div
                    class="button is-small"
                    :data-tooltip="$t('copy to clipboard')"
                    @click="copy_to_clipboard"
                  >
                    <span class="icon">
                      <i class="fa fa-copy"></i>
                    </span>
                  </div>
                </li>
                <li>{{ $t("deposit photo or transference screenshot") }}</li>
                <li>{{ $t("total payment") }}</li>
              </ul>
              <div v-html="$t('PAYMENT_DISCLAIMER_FOOTER')"></div>
            </div>
          </div>
        </div>
      </article>
      <div class="title is-4">{{ $t("contact information") }}</div>
      <form>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("student's name") }}</label>
              <div class="control">
                <input
                  type="text"
                  class="input"
                  v-model="meta.name"
                  :placeholder="$t('my child name')"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("email") }}</label>
              <div class="control">
                <input
                  type="text"
                  class="input"
                  v-model="meta.email"
                  placeholder="mi-email@correo.com"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("email confirmation") }}</label>
              <div class="control">
                <input
                  type="text"
                  class="input"
                  v-model="meta.email_confirmation"
                  placeholder="mi-email@correo.com"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("phone") }}</label>
              <div class="control">
                <input
                  type="number"
                  class="input"
                  v-model="meta.phone"
                  placeholder="5543 2211"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label"
                >{{ $t("grade") }} / {{ $t("program") }}</label
              >
              <div class="select">
                <select v-model="meta.grade" v-if="order_link">
                  <option value="">{{ $t("select one") }}</option>
                  <option
                    :value="classroom.name"
                    v-for="(classroom, cidx) in order_link.classrooms"
                    :key="cidx"
                  >
                    {{ classroom.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="title is-4">{{ $t("select your products") }}</div>

        <div class="grid is-col-min-12">
          <div class="cell" v-for="(product, pidx) in order_link.products">
            <div class="card">
              <div class="card-image">
                <figure class="image is-4by3">
                  <v-lazy-image
                    v-if="
                      product.product &&
                      product.product.settings &&
                      product.product.settings.images &&
                      product.product.settings.images.length
                    "
                    :src="`${api_host}/drive/static/${product.product.settings.images[0].final_name}`"
                  />
                  <img
                    v-else
                    src="https://bulma.io/assets/images/placeholders/1280x960.png"
                  />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-content">
                    <div class="is-pulled-right">
                      <div class="button" @click="remove_product(product)">
                        <span class="icon">
                          <i class="fa fa-minus"></i>
                        </span>
                      </div>
                      <div class="button is-primary" v-if="product.quantity">
                        {{ product.quantity }}
                      </div>
                      <div class="button" @click="add_product(product)">
                        <span class="icon">
                          <i class="fa fa-plus"></i>
                        </span>
                      </div>
                    </div>
                    <p
                      class="title is-4"
                      v-bind:class="{ 'has-text-primary': product.quantity }"
                    >
                      {{ product.product.name }}
                    </p>
                    <p class="subtitle is-6">
                      {{ format_currency(product.price) }}
                    </p>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-two-fifths">
                    <div class="field" v-if="product.quantity">
                      <label class="label">{{ $t("size") }}</label>
                      <div class="select">
                        <select
                          v-if="product && product.available_sizes"
                          v-model="product.selected_size"
                        >
                          <option value="">{{ $t("select size") }}</option>
                          <option
                            v-for="(size, sidx) in Object.keys(
                              product.available_sizes
                            )
                              .map((k) => {
                                return {
                                  itm: k,
                                  value: product.available_sizes[k],
                                };
                              })
                              .filter((k) => k.value)
                              .sort((a, b) => {
                                let target_order = [
                                  '2',
                                  '4',
                                  '6',
                                  '8',
                                  '10',
                                  '12',
                                  '14',
                                  '16',
                                  's',
                                  'm',
                                  'l',
                                  'xl',
                                  '28',
                                  '30',
                                  '32',
                                  '34',
                                  '36',
                                  '38',
                                  '40',
                                  'uniq',
                                ];

                                let idx_a = target_order.indexOf(a.itm);
                                let idx_b = target_order.indexOf(b.itm);

                                if (idx_a < idx_b) return -1;
                                if (idx_a > idx_b) return 1;
                                return 0;
                              })"
                            :value="size.itm"
                          >
                            {{ size.itm.toUpperCase() }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="field" v-if="product.quantity">
                      <label class="label">{{ $t("customization") }}</label>
                      <div class="control">
                        <textarea
                          class="textarea"
                          rows="2"
                          v-model="product.customization"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>

      <div class="content" v-if="order_summary && order_summary.length">
        <div class="title is-4">{{ $t("order summary") }}</div>
        <ul>
          <li v-for="(itm, iidx) in order_summary" :key="iidx">
            <div class="title is-5">
              {{ itm.quantity }} x {{ itm.name }} =
              {{ format_currency(itm.total) }}
            </div>
            <div class="subtitle is-5 mb-0">
              {{ $t("size") }}:
              <span v-if="itm.size">{{ itm.size.toUpperCase() }}</span>
              <div class="tag is-danger" v-else>
                {{ $t("no size selected") }}
              </div>
            </div>
            <div class="subtitle is-5" v-if="itm.customization">
              {{ $t("customization") }}: {{ itm.customization }}
            </div>
            <!-- <pre>{{ itm }}</pre> -->
          </li>
        </ul>
      </div>

      <article class="message is-info mt-3">
        <div class="message-body">
          {{
            $t(
              "to place your order, verify you fill all contact fields and you have selected size for every selected product"
            )
          }}
        </div>
      </article>
    </div>

    <section class="" v-if="step == 'payment'">
      <div class="title is 3">
        {{ $t("payment register") }}
      </div>
      <div class="form">
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("type") }}</label>
              <div class="control">
                <div class="select" v-if="order_link">
                  <select v-model="meta.payment_type">
                    <option
                      :value="pm"
                      v-for="(pm, pidx) in order_link.available_payment_methods"
                      :key="pidx"
                    >
                      {{ $t(pm) }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("date") }}</label>
              <generic-calendar
                type="date"
                display_mode="dialog"
                ref="date_calendar"
                @selected="payment_date_changed"
              />
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("amount") }}</label>
              <div class="control has-icons-left has-icons-right">
                <input
                  class="input is-medium"
                  type="text"
                  v-model="meta.payment_amount"
                  readonly="readonly"
                />
                <span class="icon is-left">
                  <i class="fa fa-credit-card"></i>
                </span>
              </div>
            </div>
          </div>
          <div
            class="column"
            v-if="['transference', 'deposit'].includes(meta.payment_type)"
          >
            <div class="field">
              <label class="label">{{ $t("document screenshot") }}</label>
              <div class="control">
                <generic-uploader
                  ref="generic_uploader"
                  :idle_label="$t('drop document photo here')"
                  endpoint_url="/tailoring_order/link/document"
                  @error="error_uploading"
                  @success="success_uploading"
                />
                <!-- <input
                  type="text"
                  class="input"
                  v-model="meta.payment_document_number"
                /> -->
              </div>
            </div>
          </div>
          <div class="column" v-if="['cash'].includes(meta.payment_type)">
            <label class="label">{{ $t("receipt number") }}</label>
            <div class="field has-addons">
              <div class="control">
                <input
                  type="text"
                  class="input"
                  v-model="meta.payment_receipt_number"
                />
              </div>
              <div class="control">
                <div
                  class="button is-warning"
                  @click="check_receipt"
                  v-if="!is_verified"
                >
                  <span class="icon">
                    <i class="fa fa-check"></i>
                  </span>
                  <span>{{ $t("check") }}</span>
                </div>
                <div class="button is-primary" v-else>
                  <span class="icon">
                    <i class="fa fa-check"></i>
                  </span>
                  <span>{{ $t("verified") }}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="column"
            v-if="['transference'].includes(meta.payment_type)"
          >
            <div class="field">
              <label class="label">{{ $t("bank") }}</label>
              <div class="control">
                <div class="select">
                  <select v-model="meta.payment_bank">
                    <option>BI</option>
                    <option>Banrural</option>
                    <option>G&T Continental</option>
                    <option>BAM</option>
                    <option>BAC</option>
                    <option>Promerica</option>
                    <option>Bantrab</option>
                    <option>Banco Internacional</option>
                    <option>CHN</option>
                    <option>Otros</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <article class="message is-success" v-show="success && false">
          <div class="message-header">
            <p>{{ $t("payment registered") }}</p>
          </div>
          <div class="message-body">
            {{ $t("your payment has been registered") }}
          </div>
        </article>
      </div>
      <!-- <pre>{{ meta }}{{ order }}</pre> -->
    </section>

    <div class="content" v-if="step == 'thanks'">
      <div class="content">
        <figure class="image is-1by1">
          <img
            src="https://api_ace.gomodul.com/drive/static/224a7da6-d224-4285-987c-53a390230bcf_thanksv.jpeg"
          />
        </figure>
      </div>
    </div>

    <div class="field mt-4">
      <div class="control">
        <button
          :disabled="false"
          class="button is-rounded is-primary"
          v-if="step == 'payment'"
          @click="back_step"
        >
          <span class="icon">
            <i class="fa fa-arrow-left"></i>
          </span>
          <span>{{ $t("back") }}</span>
        </button>
        <button
          class="button is-rounded is-primary"
          :disabled="is_order_invalid"
          v-if="step == 'order'"
          @click="next_step"
        >
          <span class="icon">
            <i class="fa fa-arrow-right"></i>
          </span>
          <span>{{ $t("register payment") }}</span>
        </button>
        <button
          :disabled="is_payment_invalid"
          class="button is-rounded is-primary ml-2"
          v-if="step == 'payment'"
          v-bind:class="{ 'is-loading': loading }"
          @click="create"
        >
          <span class="icon">
            <i class="fa fa-check"></i>
          </span>
          <span>{{ $t("confirm order") }}</span>
        </button>
        <div class="tag is-large is-warning is-rounded ml-2">
          {{ $t("total") }} {{ format_currency(total) }}
        </div>
      </div>
    </div>
    <!-- <pre>{{ meta }}{{ order_link }}</pre> -->
  </section>
</template>

<script>
import {
  get,
  post,
  error_message,
  success_message,
  format_currency,
  api_host,
} from "@/utils";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import moment from "moment";
import VLazyImage from "v-lazy-image";

export default {
  name: "TailoringOrderOrder",
  components: { GenericCalendar, VLazyImage, GenericUploader },
  // props: {
  //   order_link: {
  //     type: Object,
  //     required: true,
  //   },
  // },
  computed: {
    total() {
      let v = this;
      if (v.order_link && v.order_link.products) {
        return v.order_link.products
          .filter((p) => p.quantity)
          .reduce((prev, curr) => {
            return prev + curr.quantity * Number(curr.price);
          }, 0);
      } else return 0;
    },
    is_order_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.name ||
        !v.meta.email ||
        !v.meta.phone ||
        !v.meta.grade ||
        v.order_link.products.filter((p) => p.quantity).length == 0 ||
        v.order_link.products.find((p) => p.quantity && !p.selected_size) ||
        !v.meta.email_confirmation ||
        v.meta.email != v.meta.email_confirmation
      );
    },
    is_payment_invalid() {
      let v = this;
      return (
        !v.meta.payment_type ||
        !v.meta.payment_amount ||
        !v.meta.payment_date ||
        isNaN(v.meta.payment_amount) ||
        (["transference"].includes(v.meta.payment_type) &&
          /* !v.meta.payment_document_number */ (!v.meta
            .payment_document_temp_path ||
            !v.meta.payment_bank)) ||
        (v.meta.payment_type == "cash" && !v.meta.payment_receipt_number) ||
        (["deposit"].includes(v.meta.payment_type) &&
          !v.meta.payment_document_temp_path) ||
        (["cash"].includes(v.meta.payment_type) && !v.is_verified)
        /* !v.meta.payment_document_number */
      );
    },
    order_summary() {
      let v = this;
      let summary = [];
      if (v.order_link && v.order_link.products) {
        summary = v.order_link.products
          .filter((p) => p.quantity)
          .map((p) => {
            return {
              name: p.name,
              quantity: p.quantity,
              total: Number(p.quantity) * Number(p.price),
              size: p.selected_size,
              customization: p.customization,
            };
          });
      }

      return summary;
    },
  },
  data() {
    return {
      api_host,
      step: "order",
      order_link: {},
      loading: false,
      meta: {
        name: "",
        email: "",
        phone: "",
        grade: "",
        selected_products: [],
      },
      show: true,
      is_verified: false,
    };
  },
  methods: {
    format_currency,
    create() {
      let v = this;
      let products = v.meta.selected_products.map((sp) => {
        delete sp.product.available_sizes;
        return sp;
      });
      v.meta.selected_products = products;
      v.$root.loader(true);
      v.loading = true;

      let data = {
        order: v.meta,
        source: v.order_link.url_name,
      };

      let selected_products = v.order_link.products.filter((p) => p.quantity);
      data.order.selected_products = selected_products.map((p) => {
        return {
          product: p.product,
          price: p.price,
          quantity: p.quantity,
          size: p.selected_size,
          customization: p.customization,
        };
      });

      post("/tailoring_order/link/order", data)
        .then((order_uuid) => {
          v.$root.loader(false);
          v.loading = false;
          v.step = "thanks";
          setTimeout(() => {
            location.reload();
          }, 10000);
        })
        .catch((error) => {
          v.$root.loader(false);
          v.loading = false;
          error_message(error);
          console.error(error);
        });
    },
    // add_product(product, size) {
    //   let v = this;
    //   if (size) {
    //     let quantity = document.querySelector(
    //       `input[data-product="${product.uuid}"]`
    //     ).value;
    //     v.meta.selected_products.push({
    //       quantity: quantity,
    //       product: product,
    //       size: size,
    //     });
    //     success_message(v.$t("product added"));
    //   }
    // },
    add_product(product) {
      let v = this;
      if (product.quantity) product.quantity++;
      else product.quantity = 1;
    },
    remove_product(product) {
      let v = this;
      if (product.quantity) product.quantity--;
      else product.quantity = 0;
    },
    show_component() {
      let v = this;
      v.show = true;
    },
    hide() {
      let v = this;
      v.show = false;
    },
    set_order_link(order_link) {
      let v = this;
      v.order_link = order_link;
    },
    next_step() {
      let v = this;
      v.meta.payment_amount = v.total;
      v.step = "payment";
    },
    back_step() {
      let v = this;
      v.step = "order";
    },
    payment_date_changed(date) {
      console.log(date);
      let v = this;
      v.meta.payment_date = moment(date).format("DD/MM/YYYY");
    },
    error_uploading(error) {
      // let v = this;
      error_message(error);
    },
    success_uploading(data) {
      let v = this;
      let _data = data.serverId;
      v.meta.payment_document_temp_path = _data;
    },
    copy_to_clipboard() {
      let v = this;
      let el = document.createElement("textarea");
      el.value = v.order_link.bank_account_number;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      success_message(v.$t("copied to clipboard"));
    },
    check_receipt() {
      let v = this;
      get("/tailoring_order/link/check-receipt", {
        number: v.meta.payment_receipt_number.trim(),
        amount: v.meta.payment_amount,
      })
        .then((response) => {
          v.is_verified = true;
        })
        .catch((error) => {
          if (error.status == 409)
            error_message(v.$t("receipt already registered"));
          else if (error.status == 404)
            error_message(v.$t("receipt not found"));
          else {
            error_message(error);
          }
        });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
